import React, { useState } from 'react';
import ImageChooseModal from "../../../components/images/modal";

interface ImageURLFieldProps {
  fieldLabel: string;
  description?: string;
  value: string;
  onChange: (value: string) => void;
  commonProps?: React.HTMLAttributes<HTMLDivElement>;
}

const ImageURLField: React.FC<ImageURLFieldProps> = ({
  fieldLabel,
  description,
  value,
  onChange,
  commonProps
}) => {
  const [isOpenImageModal, setIsOpenImageModal] = useState<boolean>(false);

  const onSelectedSave = (data: any[]) => {
    if (data.length > 0 && data[0].image) {
      onChange(data[0].image);
      setIsOpenImageModal(false);
    }
  };

  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };

  const handleClearImage = () => {
    onChange('');
  };

  return (
    <div {...commonProps} className="w-full">
      <label className="block text-sm font-medium text-gray-800 mb-2">
        {fieldLabel}
      </label>
      <div className="flex flex-col sm:flex-row gap-3">
        <div className="flex-grow">
          <input
            type="url"
            value={value || ''}
            onChange={handleOnChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#528E33]/50 focus:border-[#528E33]"
            placeholder="Paste image URL or choose an image"
          />
        </div>
        <div className="flex space-x-2">
          <button
            type="button"
            onClick={() => setIsOpenImageModal(true)}
            className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-[#528E33] hover:bg-[#3E6B27] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#528E33]"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
            Choose Image
          </button>
          {value && (
            <button
              type="button"
              onClick={handleClearImage}
              className="inline-flex items-center px-3 py-2 border border-transparent text-sm font-medium rounded-md text-[#528E33] bg-[#528E33]/10 hover:bg-[#528E33]/20 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#528E33]"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          )}
        </div>
      </div>

      {value && (
        <div className="mt-4 relative max-w-xs mx-auto sm:mx-0">
          <img 
            src={value} 
            alt="Preview" 
            className="w-full h-auto max-h-48 object-cover rounded-lg shadow-md" 
          />
        </div>
      )}

      {description && (
        <p className="mt-2 text-sm text-gray-600">{description}</p>
      )}

      <ImageChooseModal 
        isOpen={isOpenImageModal} 
        onClose={() => setIsOpenImageModal(false)} 
        isMull 
        onSelectedSave={onSelectedSave}
      />
    </div>
  );
};

export default ImageURLField;